var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"336px","align-items":"center"}},[_c('center',[_c('Icon',{staticStyle:{"font-size":"18px","display":"inline-block","vertical-align":"middle"},style:('font-size: ' + (_vm.element.size ? _vm.element.size : '150px') + ';'),attrs:{"icon":_vm.element.icon ? _vm.element.icon : 'ph:warning-octagon-thin'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }